import { render } from "./ScheduleToolbelt.vue?vue&type=template&id=3672afb6"
import script from "./ScheduleToolbelt.vue?vue&type=script&lang=js"
export * from "./ScheduleToolbelt.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__